import './webpack_ready/components/AlignContent';
import lazyLoadInit from './webpack_ready/components/LazyLoad';
// import './webpack_ready/components/LazyLoad';
import './webpack_ready/components/BlindsConfigurator';
import './webpack_ready/components/BrochureOrderItemSpot';
import './webpack_ready/components/CollapsibleSpot';
import './webpack_ready/components/header/Desktop-menu';
import './webpack_ready/components/header/CountrySelector';
import './webpack_ready/components/header/Country-banner';
import './webpack_ready/components/DealerPage';
import './webpack_ready/components/Expander';
import './webpack_ready/components/FacebookSpot';
import './webpack_ready/components/FaqAPISpot';
import './webpack_ready/components/FaqSpot';
import './webpack_ready/components/FileBrowserSpot';
import './webpack_ready/components/Footer';
import './webpack_ready/components/Gallery';
import './webpack_ready/components/HeroFluentImages';
import './webpack_ready/components/HorizontalList';
import './webpack_ready/components/Iframe';
import './webpack_ready/components/Images';
import './webpack_ready/components/MegaMenu';
import './webpack_ready/components/NewsFeed';
import './webpack_ready/components/MobileMenu';
import './webpack_ready/components/MosaicSpot';
import './webpack_ready/components/ProductColor';
import './webpack_ready/components/ProductHighlights';
import './webpack_ready/components/QuestionnarieSpot';
import './webpack_ready/components/ReadMore';
import './webpack_ready/components/ResponsiveTables';
import './webpack_ready/components/ReturnTop';
import './webpack_ready/components/ShadowboxCall';
import './webpack_ready/components/Slideshow';
import './webpack_ready/components/Search';
import './webpack_ready/components/SearchSuggest';
import './webpack_ready/components/SelectorSpot';
import './webpack_ready/components/SpecificationSpot';
import './webpack_ready/components/StickyMenu';
import './webpack_ready/components/StickyMenuProducts';
import './webpack_ready/components/TabComponent';
import './webpack_ready/components/TagTheme';
import './webpack_ready/components/TexturePickerSpot';
import './webpack_ready/components/WhyVelux';
import './webpack_ready/components/VeluxActiveAppDemo';
import './webpack_ready/Spots/accordion_spot';
import './webpack_ready/Spots/beforeAfter_spot';
import './webpack_ready/Spots/cookieBot';
import './webpack_ready/components/geolocator';
import 'GlobalsScript/is-page-editor';
import './webpack_ready/components/languagePopupSelection';
import './webpack_ready/components/TimelineSpot';
import './webpack_ready/components/imageTooltips';
import './webpack_ready/components/newsSlider';
import './webpack_ready/components/dropDownMenuSpot';
import './webpack_ready/components/Byggebasen';
import '../../../Views/Marketing/Next/ContentBlock/FullscreenTakeover/fullscreen-takeover';
import '../../../Views/Marketing/Next/ContentBlock/Video/video-cookie-popup';
console.log('v.1');

import baguetteBox from "baguettebox.js";
window.baguetteBox = baguetteBox;
window.jQuery = jQuery;
import 'GlobalsScript/GtmTraking';
import trackGoogleEvent from "./common/googleanalytics";
import ctaEventDataLayer from "./common/ctaEvents";
global.trackGoogleEvent = trackGoogleEvent;
global.ctaEventDataLayer = ctaEventDataLayer;

lazyLoadInit();